// // import React, { useState, useEffect } from 'react';
// // import { Card, CardContent } from '@/components/ui/card';
// // import { Button } from '@/components/ui/button';
// // import { Input } from '@/components/ui/input';
// // import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
// // import { Badge } from '@/components/ui/badge';
// // import { FaSearch, FaTrash, FaEdit, FaSignOutAlt, FaUsers, FaEnvelope, FaPhone } from 'react-icons/fa';

// // const API_URL = 'https://linkinprofessionals.com/back_up/wp-json/vlinkin/v1';

// // export default function AdminDashboard() {
// //   const [contacts, setContacts] = useState([]);
// //   const [filteredContacts, setFilteredContacts] = useState([]);
// //   const [searchTerm, setSearchTerm] = useState('');
// //   const [loading, setLoading] = useState(true);

// //   useEffect(() => {
// //     fetchContacts();
// //   }, []);

// //   useEffect(() => {
// //     const filtered = contacts.filter(contact =>
// //       contact.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
// //       contact.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
// //       contact.program.toLowerCase().includes(searchTerm.toLowerCase())
// //     );
// //     setFilteredContacts(filtered);
// //   }, [searchTerm, contacts]);

// //   const fetchContacts = async () => {
// //     try {
// //       const response = await fetch(`${API_URL}/contact`);
// //       const data = await response.json();
// //       setContacts(data);
// //       setFilteredContacts(data);
// //     } catch (error) {
// //       console.error('Error fetching contacts:', error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleDelete = async (id) => {
// //     if (!window.confirm('Are you sure you want to delete this submission?')) return;

// //     try {
// //       await fetch(`${API_URL}/contact/${id}`, {
// //         method: 'DELETE',
// //       });
// //       fetchContacts();
// //     } catch (error) {
// //       console.error('Delete failed:', error);
// //     }
// //   };

// //   return (
// //     <div className="min-h-screen bg-slate-50 p-6">
// //       <div className="max-w-7xl mx-auto space-y-6">
// //         <div className="flex justify-between items-center">
// //           <div>
// //             <h1 className="text-4xl font-bold text-slate-800">Admin Dashboard</h1>
// //             <p className="text-slate-500 mt-2">Manage Contact Submissions</p>
// //           </div>
// //           <Button variant="destructive" className="rounded-2xl">
// //             <FaSignOutAlt className="mr-2 h-4 w-4" /> Logout
// //           </Button>
// //         </div>

// //         <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
// //           <Card className="rounded-2xl shadow-lg">
// //             <CardContent className="p-6 flex items-center gap-4">
// //               <FaUsers className="h-10 w-10 text-blue-600" />
// //               <div>
// //                 <p className="text-sm text-slate-500">Total Leads</p>
// //                 <h2 className="text-3xl font-bold">{contacts.length}</h2>
// //               </div>
// //             </CardContent>
// //           </Card>

// //           <Card className="rounded-2xl shadow-lg md:col-span-3">
// //             <CardContent className="p-6">
// //               <div className="relative">
// //                 <FaSearch className="absolute left-3 top-3 h-5 w-5 text-slate-400" />
// //                 <Input
// //                   placeholder="Search by name, email or program..."
// //                   className="pl-12 rounded-xl"
// //                   value={searchTerm}
// //                   onChange={(e) => setSearchTerm(e.target.value)}
// //                 />
// //               </div>
// //             </CardContent>
// //           </Card>
// //         </div>

// //         <Card className="rounded-2xl shadow-xl">
// //           <CardContent className="p-0">
// //             <Table>
// //               <TableHeader>
// //                 <TableRow>
// //                   <TableHead>Name</TableHead>
// //                   <TableHead>Email</TableHead>
// //                   <TableHead>Phone</TableHead>
// //                   <TableHead>Program</TableHead>
// //                   <TableHead>Message</TableHead>
// //                   <TableHead>Date</TableHead>
// //                   <TableHead>Actions</TableHead>
// //                 </TableRow>
// //               </TableHeader>
// //               <TableBody>
// //                 {loading ? (
// //                   <TableRow>
// //                     <TableCell colSpan={7} className="text-center py-10">
// //                       Loading...
// //                     </TableCell>
// //                   </TableRow>
// //                 ) : filteredContacts.length === 0 ? (
// //                   <TableRow>
// //                     <TableCell colSpan={7} className="text-center py-10">
// //                       No submissions found.
// //                     </TableCell>
// //                   </TableRow>
// //                 ) : (
// //                   filteredContacts.map((contact) => (
// //                     <TableRow key={contact.id}>
// //                       <TableCell className="font-medium">{contact.name}</TableCell>
// //                       <TableCell>{contact.email}</TableCell>
// //                       <TableCell>{contact.phone}</TableCell>
// //                       <TableCell>
// //                         <Badge>{contact.program}</Badge>
// //                       </TableCell>
// //                       <TableCell className="max-w-xs truncate">{contact.message}</TableCell>
// //                       <TableCell>{contact.timestamp}</TableCell>
// //                       <TableCell>
// //                         <div className="flex gap-2">
// //                           <Button size="icon" variant="outline">
// //                             <FaEdit className="h-4 w-4" />
// //                           </Button>
// //                           <Button
// //                             size="icon"
// //                             variant="destructive"
// //                             onClick={() => handleDelete(contact.id)}
// //                           >
// //                             <FaTrash className="h-4 w-4" />
// //                           </Button>
// //                         </div>
// //                       </TableCell>
// //                     </TableRow>
// //                   ))
// //                 )}
// //               </TableBody>
// //             </Table>
// //           </CardContent>
// //         </Card>
// //       </div>
// //     </div>
// //   );
// // }
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   FaSearch,
//   FaTrash,
//   FaEdit,
//   FaSignOutAlt,
//   FaUsers,
// } from "react-icons/fa";

// const API_URL =
//   "https://linkinprofessionals.com/back_up/wp-json/vlinkin/v1";

// function AdminDashboard() {
//   const navigate = useNavigate();

//   const [contacts, setContacts] = useState([]);
//   const [filteredContacts, setFilteredContacts] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchContacts();
//   }, []);

//   useEffect(() => {
//     const filtered = contacts.filter(
//       (contact) =>
//         contact.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         contact.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         contact.program?.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     setFilteredContacts(filtered);
//   }, [searchTerm, contacts]);

//   const fetchContacts = async () => {
//     try {
//       const response = await fetch(`${API_URL}/contact`);
//       const data = await response.json();

//       setContacts(Array.isArray(data) ? data : []);
//       setFilteredContacts(Array.isArray(data) ? data : []);
//     } catch (error) {
//       console.error("Error fetching contacts:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDelete = async (id) => {
//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this contact?"
//     );

//     if (!confirmDelete) return;

//     try {
//       await fetch(`${API_URL}/contact/${id}`, {
//         method: "DELETE",
//       });

//       fetchContacts();
//     } catch (error) {
//       console.error("Delete failed:", error);
//       alert("Unable to delete contact.");
//     }
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("adminAuth");
//     localStorage.removeItem("adminUser");
//     navigate("/");
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-100 to-slate-200 p-6">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="bg-white rounded-3xl shadow-xl p-6 mb-8 flex flex-col md:flex-row justify-between items-center">
//           <div>
//             <h1 className="text-4xl font-bold text-slate-800">
//               Admin Dashboard
//             </h1>
//             <p className="text-slate-500 mt-2">
//               Manage Contact Form Submissions
//             </p>
//           </div>

//           <button
//             onClick={handleLogout}
//             className="mt-4 md:mt-0 flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-xl font-semibold transition duration-300"
//           >
//             <FaSignOutAlt />
//             Logout
//           </button>
//         </div>

//         {/* Statistics */}
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
//           <div className="bg-white rounded-3xl shadow-lg p-6 flex items-center gap-4">
//             <div className="bg-blue-100 p-4 rounded-2xl">
//               <FaUsers className="text-4xl text-blue-600" />
//             </div>
//             <div>
//               <p className="text-slate-500">Total Leads</p>
//               <h2 className="text-4xl font-bold text-slate-800">
//                 {contacts.length}
//               </h2>
//             </div>
//           </div>

//           <div className="md:col-span-3 bg-white rounded-3xl shadow-lg p-6">
//             <div className="relative">
//               <FaSearch className="absolute left-4 top-4 text-slate-400 text-xl" />

//               <input
//                 type="text"
//                 placeholder="Search by name, email or program..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full pl-14 pr-4 py-4 border border-slate-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Table */}
//         <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead className="bg-gradient-to-r from-blue-600 to-purple-600 text-white">
//                 <tr>
//                   <th className="px-6 py-4 text-left">Name</th>
//                   <th className="px-6 py-4 text-left">Email</th>
//                   <th className="px-6 py-4 text-left">Phone</th>
//                   <th className="px-6 py-4 text-left">Program</th>
//                   <th className="px-6 py-4 text-left">Message</th>
//                   <th className="px-6 py-4 text-left">Date</th>
//                   <th className="px-6 py-4 text-center">Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td
//                       colSpan="7"
//                       className="text-center py-12 text-xl text-slate-500"
//                     >
//                       Loading contacts...
//                     </td>
//                   </tr>
//                 ) : filteredContacts.length === 0 ? (
//                   <tr>
//                     <td
//                       colSpan="7"
//                       className="text-center py-12 text-xl text-slate-500"
//                     >
//                       No contacts found.
//                     </td>
//                   </tr>
//                 ) : (
//                   filteredContacts.map((contact, index) => (
//                     <tr
//                       key={contact.id}
//                       className={`border-b hover:bg-slate-50 transition ${
//                         index % 2 === 0 ? "bg-white" : "bg-slate-50"
//                       }`}
//                     >
//                       <td className="px-6 py-4 font-semibold text-slate-800">
//                         {contact.name}
//                       </td>

//                       <td className="px-6 py-4">{contact.email}</td>

//                       <td className="px-6 py-4">{contact.phone}</td>

//                       <td className="px-6 py-4">
//                         <span className="bg-blue-100 text-blue-700 px-4 py-1 rounded-full text-sm font-medium">
//                           {contact.program}
//                         </span>
//                       </td>

//                       <td className="px-6 py-4 max-w-xs truncate">
//                         {contact.message}
//                       </td>

//                       <td className="px-6 py-4">
//                         {new Date(contact.timestamp).toLocaleDateString()}
//                       </td>

//                       <td className="px-6 py-4">
//                         <div className="flex justify-center gap-3">
//                           <button
//                             className="bg-yellow-500 hover:bg-yellow-600 text-white p-3 rounded-xl transition"
//                             title="Edit"
//                           >
//                             <FaEdit />
//                           </button>

//                           <button
//                             onClick={() => handleDelete(contact.id)}
//                             className="bg-red-500 hover:bg-red-600 text-white p-3 rounded-xl transition"
//                             title="Delete"
//                           >
//                             <FaTrash />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AdminDashboard;
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaSearch,
  FaReply,
  FaSignOutAlt,
  FaUsers,
} from "react-icons/fa";

const API_URL =
  "https://linkinprofessionals.com/back_up/wp-json/vlinkin/v1";

function AdminDashboard() {
  const navigate = useNavigate();

  const [contacts, setContacts] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContacts();
  }, []);

  useEffect(() => {
    const filtered = contacts.filter(
      (contact) =>
        contact.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        contact.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        contact.program?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setFilteredContacts(filtered);
  }, [searchTerm, contacts]);

  const fetchContacts = async () => {
    try {
      const response = await fetch(`${API_URL}/contact`);
      const data = await response.json();

      setContacts(Array.isArray(data) ? data : []);
      setFilteredContacts(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    } finally {
      setLoading(false);
    }
  };

  // Opens Gmail's web compose window directly (new tab), pre-filled with
  // the contact's email address, subject, and greeting body. The admin
  // only needs to review/finish the message and hit send — no "to" typing,
  // no app picker.
  const handleReply = (contact) => {
    if (!contact.email) {
      alert("This contact has no email address on file.");
      return;
    }

    const subject = encodeURIComponent(
      `Re: Your inquiry${contact.program ? ` - ${contact.program}` : ""}`
    );
    const body = encodeURIComponent(
      `Hi ${contact.name || ""},\n\nThank you for reaching out to VLinkin Professionals LLP.\n\n`
    );

    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
      contact.email
    )}&su=${subject}&body=${body}`;

    window.open(gmailComposeUrl, "_blank");
  };

  const handleLogout = () => {
    localStorage.removeItem("adminAuth");
    localStorage.removeItem("adminUser");
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 to-slate-200 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-3xl shadow-xl p-6 mb-8 flex flex-col md:flex-row justify-between items-center">
          <div>
            <h1 className="text-4xl font-bold text-slate-800">
              Admin Dashboard
            </h1>
            <p className="text-slate-500 mt-2">
              Manage Contact Form Submissions
            </p>
          </div>

          <button
            onClick={handleLogout}
            className="mt-4 md:mt-0 flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-xl font-semibold transition duration-300"
          >
            <FaSignOutAlt />
            Logout
          </button>
        </div>

        {/* Statistics */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-3xl shadow-lg p-6 flex items-center gap-4">
            <div className="bg-blue-100 p-4 rounded-2xl">
              <FaUsers className="text-4xl text-blue-600" />
            </div>
            <div>
              <p className="text-slate-500">Total Leads</p>
              <h2 className="text-4xl font-bold text-slate-800">
                {contacts.length}
              </h2>
            </div>
          </div>

          <div className="md:col-span-3 bg-white rounded-3xl shadow-lg p-6">
            <div className="relative">
              <FaSearch className="absolute left-4 top-4 text-slate-400 text-xl" />

              <input
                type="text"
                placeholder="Search by name, email or program..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-14 pr-4 py-4 border border-slate-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gradient-to-r from-blue-600 to-purple-600 text-white">
                <tr>
                  <th className="px-6 py-4 text-left">Name</th>
                  <th className="px-6 py-4 text-left">Email</th>
                  <th className="px-6 py-4 text-left">Phone</th>
                  <th className="px-6 py-4 text-left">Program</th>
                  <th className="px-6 py-4 text-left">Message</th>
                  <th className="px-6 py-4 text-left">Date</th>
                  <th className="px-6 py-4 text-center">Actions</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center py-12 text-xl text-slate-500"
                    >
                      Loading contacts...
                    </td>
                  </tr>
                ) : filteredContacts.length === 0 ? (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center py-12 text-xl text-slate-500"
                    >
                      No contacts found.
                    </td>
                  </tr>
                ) : (
                  filteredContacts.map((contact, index) => (
                    <tr
                      key={contact.id}
                      className={`border-b hover:bg-slate-50 transition ${
                        index % 2 === 0 ? "bg-white" : "bg-slate-50"
                      }`}
                    >
                      <td className="px-6 py-4 font-semibold text-slate-800">
                        {contact.name}
                      </td>

                      <td className="px-6 py-4">{contact.email}</td>

                      <td className="px-6 py-4">{contact.phone}</td>

                      <td className="px-6 py-4">
                        <span className="bg-blue-100 text-blue-700 px-4 py-1 rounded-full text-sm font-medium">
                          {contact.program}
                        </span>
                      </td>

                      <td className="px-6 py-4 max-w-xs truncate">
                        {contact.message}
                      </td>

                      <td className="px-6 py-4">
                        {new Date(contact.timestamp).toLocaleDateString()}
                      </td>

                      <td className="px-6 py-4">
                        <div className="flex justify-center gap-3">
                          <button
                            onClick={() => handleReply(contact)}
                            className="bg-blue-500 hover:bg-blue-600 text-white p-3 rounded-xl transition"
                            title="Reply by Email"
                          >
                            <FaReply />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;